import React from 'react';
import { X, CreditCard } from 'lucide-react';
import { useCart } from '../../hooks/useCart';
import { formatVND } from '../../utils/formatters';

export default function CheckoutModal({ isOpen, onClose, onSuccess }) {
  const { setCart, finalTotal } = useCart();

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setCart([]);
    onClose();
    onSuccess('Đặt hàng thành công! Cảm ơn bạn đã mua sắm tại JapanICHIBA.');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/60 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-3xl max-w-xl w-full p-8 relative overflow-hidden shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100 transition"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-2">
            <CreditCard className="w-6 h-6" />
          </div>
          <h3 className="text-2xl font-bold text-slate-900 font-serif">Thanh Toán Đơn Hàng</h3>
          <p className="text-xs text-slate-500 mt-1">Hoàn tất thông tin để nhận hàng siêu tốc</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 text-xs">
          <div>
            <label className="block font-bold text-slate-700 mb-1">Họ và Tên</label>
            <input
              required
              type="text"
              placeholder="Nguyễn Văn A"
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-500"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block font-bold text-slate-700 mb-1">Số điện thoại</label>
              <input
                required
                type="tel"
                placeholder="0901234567"
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-500"
              />
            </div>
            <div>
              <label className="block font-bold text-slate-700 mb-1">Email</label>
              <input
                required
                type="email"
                placeholder="example@gmail.com"
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-500"
              />
            </div>
          </div>

          <div>
            <label className="block font-bold text-slate-700 mb-1">Địa chỉ giao hàng</label>
            <input
              required
              type="text"
              placeholder="Số nhà, đường, quận/huyện, tỉnh/thành"
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-500"
            />
          </div>

          <div className="pt-2 border-t border-slate-100 flex justify-between items-center text-sm">
            <span className="font-bold text-slate-700">Thành tiền:</span>
            <span className="font-extrabold text-indigo-600 text-lg">{formatVND(finalTotal)}</span>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3.5 rounded-xl transition text-sm shadow-lg shadow-indigo-600/20"
          >
            Xác Nhận Đặt Hàng ({formatVND(finalTotal)})
          </button>
        </form>
      </div>
    </div>
  );
}